/* ============================================================
   saea.js — custom global behaviors for the Saéa theme.
   Loaded once, site-wide and deferred (see layout/theme.liquid).
   Keep this lean; prefer CSS, fall back to JS only where needed.
   ============================================================ */
(function () {
  'use strict';

  /* --------------------------------------------------------
     Product card: touch-reveal the second image (mobile).
     Desktop reveals the second photo on hover — that swap is
     gated to @media (hover: hover), so touch devices (no hover)
     never see it. Here we mirror it: while a card is pressed we
     add `.is-touched`, and the matching @media (hover: none) CSS
     fades the second image in. One delegated listener covers
     every card on the page (collection grids, the PDP cross-sell,
     and load-more / lazy-added cards) with no per-card cost.
     -------------------------------------------------------- */
  function clearTouched() {
    var open = document.querySelectorAll('.saea-card-img.is-touched');
    for (var i = 0; i < open.length; i++) open[i].classList.remove('is-touched');
  }

  document.addEventListener('touchstart', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('.saea-card-img') : null;
    if (!card) return;
    clearTouched();                 // only one card revealed at a time
    card.classList.add('is-touched');
  }, { passive: true });

  document.addEventListener('touchend', clearTouched, { passive: true });
  document.addEventListener('touchcancel', clearTouched, { passive: true });
})();

/* --------------------------------------------------------
   PROTOTYPE — sticky-gallery PDP.
   On desktop (≥1000px) relocate the details accordion up into
   the buy column, right under the signature quote, so the
   product gallery can stay pinned while a taller info column
   scrolls past it. The accordion keeps its own markup, per-
   template content and single-open behavior — this only re-
   parents the node. Fully reversible: delete this block and the
   `.saea-pdp-accordion--incolumn` CSS.
   -------------------------------------------------------- */
(function () {
  'use strict';
  if (!window.matchMedia || !window.matchMedia('(min-width: 1000px)').matches) return;
  var buy = document.querySelector('.saea-pdp-buy');
  var acc = document.querySelector('.saea-pdp-accordion');
  if (!buy || !acc) return;
  var wrap = acc.closest('.shopify-section');
  buy.appendChild(acc);                       // move accordion under the buy content
  acc.classList.add('saea-pdp-accordion--incolumn');
  if (wrap) wrap.style.display = 'none';       // collapse the now-empty section slot
})();
